import { render, staticRenderFns } from "./PaymentPix.vue?vue&type=template&id=4bc61270&scoped=true"
import script from "./PaymentPix.vue?vue&type=script&lang=js"
export * from "./PaymentPix.vue?vue&type=script&lang=js"
import style0 from "./PaymentPix.vue?vue&type=style&index=0&id=4bc61270&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4bc61270",
  null
  
)

export default component.exports